<span *ngIf="hasError" [id]="erroranchor" class="error-span" [innerHtml]="error"></span>